// extracted by mini-css-extract-plugin
module.exports = {"componentsBankCardForm":"styles_componentsBankCardForm__evASN","noticeBar":"styles_noticeBar__Aw1Vq"};